import { getAPI, postAPI, putAPI, deleteAPI } from './api-service'

export const getTeamForGroupAPI = async ({ groupName }) => {
  return await getAPI('TeamAPI', `/groups/${groupName}`)
}

export const loadNotesAPI = async ({ teamName, surveyName }) => {
  const path = `/teams/${teamName}/surveys/${surveyName}/notes`
  return await getAPI('TeamAPI', path)
}

export const createNoteAPI = async ({ surveyName, teamName, note }) => {
  const path = `/teams/${teamName}/surveys/${surveyName}/notes`
  return await postAPI('TeamAPI', path, {
    body: note
  })
}

export const updateNoteAPI = async ({
  surveyName,
  updatedNote,
  teamName,
  noteName
}) => {
  const path = `/teams/${teamName}/surveys/${surveyName}/notes/${noteName}`
  return await putAPI('TeamAPI', path, {
    body: { value: updatedNote.value, to: updatedNote.to }
  })
}

export const deleteNoteAPI = async ({ surveyName, teamName, noteName }) => {
  const path = `/teams/${teamName}/surveys/${surveyName}/notes/${noteName}`
  return await deleteAPI('TeamAPI', path)
}
